import { Component } from '@angular/core';
import { BulkExportMetaData } from '@app/modules/reporting/interfaces/bulk-export-meta-data';
import { BULK_EXPORT_META_DATA } from '@reporting/views/bulk-export/bulk-export-config';

@Component({
    templateUrl: './bulk-export-selection.view.html',
})
export class BulkExportSelectionView {
    readonly exports: BulkExportMetaData[] = BULK_EXPORT_META_DATA;
}
